import { Box, Tab, Tabs as MuiTabs, type TabsProps as MuiTabsProps } from '@mui/material'
import { type ReactNode, type SyntheticEvent } from 'react'

export interface TabData {
  label: string | ReactNode
  value: number | string
  disabled?: boolean
}
export interface TabsProps<T extends TabData['value']> extends Omit<MuiTabsProps, 'value'> {
  tabData: TabData[]
  value: T
}

export const Tabs = <T extends TabData['value']>(props: TabsProps<T>) => {
  const { onChange, tabData, value, ...rest } = props
  const handleChange = (event: SyntheticEvent, newValue: T) => {
    onChange?.(event, newValue)
  }

  return (
    <Box>
      <MuiTabs
        value={value}
        onChange={handleChange}
        {...rest}
      >
        {tabData.map(tab => (
          <Tab
            key={tab.value}
            value={tab.value}
            label={tab.label}
            disabled={tab.disabled}
            sx={{
              fontWeight: 600,
              textTransform: 'capitalize',
            }}
          />
        ))}
      </MuiTabs>
    </Box>
  )
}
